// extracted by mini-css-extract-plugin
module.exports = {"section":"FarePricesSection_section__FoZIZ","container":"FarePricesSection_container__AIlO_","mosaic":"FarePricesSection_mosaic__fW8N2"};